import React, { useEffect, useState, useRef } from "react";
import { Redirect, Link, withRouter } from "react-router-dom";
import { notification } from "antd";
import axios from "axios";

import loadJitsiScript from "./loadJitsiScript";

import AttachmentsList from "./components/AttachmentsList";
import VideosList from "./components/VideosList";
import JitsiLoader from "./components/JitsiLoader";
import ModalLoading from "../shared/components/modals/ModalLoading";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const SessaoJitsi = ({ match }) => {
    const jitsiContainerId = "jitsi-container";
    const heartbeatIntervalRef = useRef(null);
    const jitsiRef = useRef(null);

    const [jitsi, setJitsi] = useState(null);
    const [sessao, setSessao] = useState(null);
    const [loading, setLoading] = useState(true);
    const [redirect, setRedirect] = useState({
        status: false,
        link: ""
    });
    const [aSair, setASair] = useState(false);
    const [videos, setVideos] = useState("");
    const [anexos, setAnexos] = useState("");
    const [permissao, setPermissao] = useState("");

    const loadSessionDetails = async () => {
        axios({
            method: "get",
            url: "/api/videoconferencia/get-meeting-details",
            params: {
                curso: localStorage.getItem("codigo_curso"),
                id: match.params.vconfid
            }
        })
            .then(response => {
                setSessao({
                    assunto: response.data.assunto,
                    meetingName: response.data.meetingName,
                    participantName: response.data.participant,
                    generatedPassword: response.data.generatedPassword,
                    moderatorID: response.data.moderatorID,
                    userID: response.data.userID,
                    gravarSessao: response.data.gravarSessao,
                    habilitarChat: response.data.habilitarChat,
                    gravarChat: response.data.gravarChat,
                    servidor: response.data.servidor
                });
                setVideos(response.data.sessaoVimeoID);
                setAnexos(response.data.ficheiro);
                setPermissao(response.data.permissaoDescarregar);
            })
            .catch(error => {
                if (error.response?.data === "SEM_PERMISSAO") {
                    setRedirect({
                        status: true,
                        link: "/user"
                    });
                } else if (error.response?.status === 401) {
                    setRedirect({
                        status: true,
                        link: "/login"
                    });
                }
            });
    };

    const participantKickedOut = (e, jitsi) => {
        if (e.kicked.local) {
            addParticipantExit(jitsi, 2);
        }
    };

    const videoConferenceLeft = (e, jitsi) => {
        addParticipantExit(jitsi, 1);
    };

    const addParticipantExit = (jitsi, tipoEvento) => {
        const cleanup = () => {
            jitsi.removeEventListener("participantKickedOut");
            jitsi.removeEventListener("videoConferenceLeft");
            jitsi.dispose();

            document.querySelectorAll("iframe").forEach(el => el.remove());

            setRedirect({
                status: true,
                link: `/curso/${match.params.curso}/curso-videoconferencias`
            });
        };

        axios
            .post("/api/videoconferencia/add-participant-exit", null, {
                params: { meetingID: match.params.vconfid, tipoEvento }
            })
            .then(cleanup)
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirect({
                        status: true,
                        link: "/login"
                    });
                } else {
                    cleanup();
                }
            });
    };

    const sendHeartbeat = () => {
        axios({
            method: "post",
            url: "/api/session/heartbeat",
            data: {
                sessionId: match.params.vconfid
            },
            timeout: 15000
        }).catch(error => {
            // if (!error.response) {
            //     openNotificationWithIcon("warning", "Falha de conexão", error.message);
            //     return; // não para a sessão por causa de rede instável
            // }
            // stopHeartbeat();
            // if (jitsiRef.current) {
            //     jitsiRef.current.dispose();
            //     jitsiRef.current = null;
            // }
            // if (error.response?.status === 401) {
            //     openNotificationWithIcon("error", "Sessão expirada!", "A sua sessão expirou. A sair...");
            //     setRedirect({ status: true, link: `/login` });
            // } else {
            //     openNotificationWithIcon("error", "Erro!", "Ocorreu um erro na sessão do Stepmeet. A sair...");
            //     setRedirect({ status: true, link: `/curso/${match.params.curso}/curso-videoconferencias` });
            // }
        });
    };

    const stopHeartbeat = () => {
        if (heartbeatIntervalRef.current) {
            clearInterval(heartbeatIntervalRef.current);
            heartbeatIntervalRef.current = null;
            console.log("Heartbeat parado.");
        }
    };

    const initialiseJitsi = async () => {
        if (!window.JitsiMeetExternalAPI) {
            await loadJitsiScript(sessao);
        }

        document.querySelectorAll("iframe").forEach(el => el.remove());

        const _jitsi = new window.JitsiMeetExternalAPI(sessao.servidor, {
            parentNode: document.getElementById(jitsiContainerId),
            roomName: sessao.meetingName,
            userInfo: { displayName: sessao.participantName },
            configOverwrite: {
                subject: sessao.assunto,
                prejoinPageEnabled: false,
                startWithAudioMuted: true,
                startWithVideoMuted: true,
                toolbarButtons: [
                    "microphone",
                    "camera",
                    "desktop",
                    "fullscreen",
                    "fodeviceselection",
                    "profile",
                    sessao.habilitarChat ? "chat" : "",
                    "sharedvideo",
                    "settings",
                    "raisehand",
                    "videoquality",
                    "filmstrip",
                    "shortcuts",
                    "tileview",
                    "select-background",
                    "mute-everyone",
                    "shareaudio",
                    "participants-pane"
                ].filter(Boolean)
            },
            interfaceConfigOverwrite: {
                SETTINGS_SECTIONS: ["devices", "more"]
            }
        });

        const selectResolution = totalParticipantes => {
            var resolution = "";
            var constraints = {};

            if (totalParticipantes <= 4) {
                resolution = 720;
                constraints = {
                    video: {
                        height: {
                            ideal: 720,
                            max: 1080,
                            min: 180
                        }
                    }
                };
            } else if (totalParticipantes <= 25) {
                resolution = 480;
                constraints = {
                    video: {
                        height: {
                            ideal: 360,
                            max: 480,
                            min: 180
                        }
                    }
                };
            } else if (totalParticipantes <= 35) {
                resolution = 360;
                constraints = {
                    video: {
                        height: {
                            ideal: 240,
                            max: 360,
                            min: 180
                        }
                    }
                };
            } else {
                resolution = 240;
                constraints = {
                    video: {
                        height: {
                            ideal: 240,
                            max: 240,
                            min: 180
                        }
                    }
                };
            }

            return {
                resolution,
                constraints
            };
        };

        var resolutionInfo = selectResolution(
            _jitsi._numberOfParticipants > sessao.totalParticipantes ? _jitsi._numberOfParticipants : sessao.totalParticipantes
        );

        _jitsi.configOverwrite = {
            ..._jitsi.configOverwrite,
            resolution: resolutionInfo.resolution,
            constraints: resolutionInfo.constraints
        };

        _jitsi.addEventListener("videoConferenceJoined", () => {
            if (_jitsi._numberOfParticipants >= 100) {
                openNotificationWithIcon("warning", "Atenção!", "Stepmeet cheio!");
                addParticipantExit(_jitsi, 1);
                setRedirect({
                    status: true,
                    link: `/curso/${match.params.curso}/curso-videoconferencias`
                });
                return;
            }

            if (_jitsi._numberOfParticipants === 1) {
                openNotificationWithIcon("warning", "Atenção!", "Stepmeet vazia! Aguarde pelo Instrutor");
                addParticipantExit(_jitsi, 1);
                setRedirect({
                    status: true,
                    link: `/curso/${match.params.curso}/vconf/${match.params.vconfid}/player-videoconferencia-aguardar`
                });
                return;
            }

            setLoading(false);
            setJitsi(_jitsi);
            jitsiRef.current = _jitsi;

            _jitsi.addEventListener("participantKickedOut", e => participantKickedOut(e, _jitsi));
            _jitsi.addEventListener("readyToClose", e => videoConferenceLeft(e, _jitsi));

            heartbeatIntervalRef.current = setInterval(sendHeartbeat, 20000);
        });
    };

    useEffect(() => {
        loadSessionDetails();
    }, []);

    useEffect(() => {
        if (sessao) initialiseJitsi();

        return () => {
            stopHeartbeat();

            if (jitsiRef.current) jitsiRef.current.dispose();
        };
    }, [sessao]);

    useEffect(() => {
        if (!aSair) return;

        stopHeartbeat();

        if (jitsiRef.current) jitsiRef.current.executeCommand("hangup");
    }, [aSair]);

    if (redirect.status) return <Redirect to={redirect.link} />;

    return (
        <>
            {loading && <JitsiLoader />}
            <div className="jitsi-meeting">
                <div id={jitsiContainerId} style={{ height: "100vh", width: "100vw" }} />
                {!loading && (
                    <div className="bloco-opcoes-player">
                        <Link
                            to="#"
                            className="opcao-player-desligar"
                            title="Sair"
                            onClick={() => {
                                setASair(true);
                                stopHeartbeat();
                            }}
                        >
                            <i className="fas fa-phone icon-hang-up" />
                        </Link>
                        {permissao && videos && <VideosList vimeoId={videos} curso={match.params.curso} />}
                        {anexos && <AttachmentsList anexos={anexos} />}
                    </div>
                )}
            </div>
            <ModalLoading visible={aSair} text="A sair..." />
        </>
    );
};

export default withRouter(SessaoJitsi);
